import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";

const ShowAllReceiptToday = (props) => {
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [deliveryDetail, setDeliveryDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [date, setdate] = useState(moment().format("YYYY-MM-DD"));
  const [saleList, setSaleList] = useState([]);
  const [saleItemList, setSaleItemList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const ITEMS_PER_PAGE = 10;
  console.log("createddate2", date);
  const handleListData = (date, locationid) => {
    console.log("createddate", date);
    console.log("locationid", locationid);
    setLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/todayreceipt?createddate=${date}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res.data.ResponseData", res.data.ResponseData.sale);
        const sale = res.data.ResponseData.sale;
        const saleItem = res.data.ResponseData.saleItem;

        console.log("saleItem", saleItem);

        setCompanyDetails(res.data.ResponseData.companydetails);

        setCustomerDetails(res.data.ResponseData.customerdetail);

        setDeliveryDetail(res.data.ResponseData.Deliverydetail);
        setSaleList(sale);
        setSaleItemList(saleItem);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  console.log("saleList==>", saleList);
  console.log("company====>", companyDetails);
  console.log("customerdetail", customerDetails);
  const handledate = (momentDate) => {
    // console.log("event", event);
    setdate(moment(momentDate).format("YYYY-MM-DD"));
    handleListData(date, 0);
  };

  // const filteredItems = saleItemList.filter((x) => x.SaleId === option.ID);
  // const totalAmount = filteredItems.reduce(
  //   (acc, item) => acc + Number(item.Total),
  //   0
  // );

  useEffect(() => {
    handleListData(date, 0);
  }, [date]);

  console.log("saleList", saleList);
  console.log("saleItemList", saleItemList);

  //Function for print
  // const handlePrint = async () => {
  //   setCurrentPage(1);
  //   const pages = document.querySelectorAll("#print");
  //   const pdf = new jsPDF();

  //   const input = pages[0];
  //   const width = input.offsetWidth;
  //   const height = input.offsetHeight;

  //   const imgData = await html2canvas(input, { width, height }).then((canvas) =>
  //     canvas.toDataURL("image/png")
  //   );

  //   pdf.addImage(
  //     imgData,
  //     "JPEG",
  //     0,
  //     0,
  //     pdf.internal.pageSize.width,
  //     pdf.internal.pageSize.height
  //   );

  //   for (let i = 1; i < pages.length; i++) {
  //     const input = pages[i];
  //     const width = input.offsetWidth;
  //     const height = input.offsetHeight;

  //     const imgData = await html2canvas(input, { width, height }).then(
  //       (canvas) => canvas.toDataURL("image/png")
  //     );

  //     pdf.addPage();
  //     pdf.addImage(
  //       imgData,
  //       "JPEG",
  //       0,
  //       0,
  //       pdf.internal.pageSize.width,
  //       pdf.internal.pageSize.height
  //     );
  //   }

  //   // Convert the PDF to a Blob object
  //   const pdfBlob = pdf.output("blob");

  //   // Create a URL for the Blob object
  //   const pdfUrl = URL.createObjectURL(pdfBlob);

  //   // Open a new window with the URL
  //   const printWindow = window.open(pdfUrl);

  //   // Wait for the window to load and then print the PDF
  //   printWindow.addEventListener("load", () => {
  //     printWindow.print();
  //   });
  // };

  //Function for lookup receipt
  const paramObject = useParams();

  useEffect(() => {
    setLoading(true);

    // console.log("setResponseData", responseData);
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res);
        setLocationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/lookupreceipt?saleid=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData.SalesItems);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [paramObject.id]);

  console.log(paramObject.id, "paramObject.id");

  //Function for export excel

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, item) => {
      const itemTotal = Number(item.Total);

      if (typeof itemTotal === "number" && !isNaN(itemTotal)) {
        return total + itemTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);
  const formatDate = (string) => {
    var options = {
      year: "numeric",

      month: "numeric",

      day: "numeric",

      // hour: "numeric",

      // minute: "numeric",

      // second: "numeric",

      // timeZone: "UTC",
    };

    return new Date(string).toLocaleString([], options);
  };

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  // Pdf Print
  // const handlePrint = () => {
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `7px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   // Add the footer
  //   let footerElement = document.querySelector("#footer");
  //   let clonedFooter = footerElement.cloneNode(true);
  //   clonedFooter.style.fontSize = `7px`;
  //   clonedFooter.style.width = "560px";
  //   clonedFooter.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 10;
  //   let carryOverSum = 0;

  //   for (var i = 1; i <= Math.ceil(responseData?.SalesItems.length / 10); i++) {
  //     // Printing page no-
  //     let pageNoElement = clonedHeader.querySelector("#page-no");
  //     pageNoElement.innerText = i;

  //     // Printing header-
  //     content += " " + clonedHeader.outerHTML;

  //     // Condition based Css-
  //     if (i > 1) {
  //       content +=
  //         '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
  //         carryOverSum.toFixed(2) +
  //         "<p></div>";
  //     }
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "3.8rem";
  //       clonedFooter.style.marginTop = "4rem";
  //     }
  //     if (i > 1 && i != Math.ceil(responseData?.SalesItems.length / 10)) {
  //       clonedFooter.style.marginTop = "1rem";
  //     }

  //     // Checking remaining Loops printing last footer-
  //     if (i == Math.ceil(responseData?.SalesItems.length / 10)) {
  //       let remainItems = Number(responseData?.SalesItems.length) % 10;
  //       let remainLoop = 10 - remainItems;

  //       clonedFooter.style.marginTop = `${remainLoop * 1.6}rem`;
  //     }

  //     // Printing table body-
  //     content +=
  //       '<table style="font-size: 7px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 8px;">S.No</th>' +
  //       '<th style="padding: 8px; width: 300px">Description</th>' +
  //       '<th style="padding: 8px;">Barcode</th>' +
  //       '<th style="padding: 8px;">Price</th>' +
  //       '<th style="padding: 8px;">Quantity</th>' +
  //       '<th style="padding: 8px;">Discount%</th>' +
  //       '<th style="padding: 8px;">Tax%</th>' +
  //       '<th style="padding: 8px;">Total</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex-
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index >= startIndex && index <= responseData?.SalesItems.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px; width: 300px;">' +
  //           '<p style="font-size: 7px; font-weight: bold; margin: 0">' +
  //           responseData?.SalesItems[index - 1].ItemName +
  //           responseData?.SalesItems[index - 1].ItemVariationName +
  //           "</p>" +
  //           "<p>" +
  //           responseData?.SalesItems[index - 1].Itemnumber +
  //           "</p>" +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           "Barcode" +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           Number(responseData?.SalesItems[index - 1].Itemunitprice).toFixed(
  //             2
  //           ) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           Number(
  //             responseData?.SalesItems[index - 1].Quantitypurchased
  //           ).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           Number(responseData?.SalesItems[index - 1].Discountpercent).toFixed(
  //             2
  //           ) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           Number(responseData?.SalesItems[index - 1].Tax).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 8px;">' +
  //           Number(responseData?.SalesItems[index - 1].Total).toFixed(2) +
  //           "</td>" +
  //           "</tr>";

  //         // Add the "Total" value to the carryOverSum on each page
  //         carryOverSum += Number(responseData?.SalesItems[index - 1].Total);
  //       }

  //       if (index % 10 == 0) {
  //         startIndex = startIndex + 10;
  //         endIndex = endIndex + 10;
  //         break;
  //       }
  //     }

  //     // Printing Total or Carry Sum condition based-
  //     if (i !== Math.ceil(responseData?.SalesItems.length / 10)) {
  //       content +=
  //         '<tr><td colspan="12" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
  //         carryOverSum.toFixed(2) +
  //         "</td></tr>";
  //     } else {
  //       content +=
  //         '<tr><td colspan="12" style="text-align: right; padding-top: 1.5rem; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Sub Total: $' +
  //         Number(salesdetails[0]?.Subtotal).toFixed(2) +
  //         "</td></tr>";

  //       content +=
  //         '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Tax: $' +
  //         Number(salesdetails[0]?.Tax).toFixed(2) +
  //         "</td></tr>";

  //       content +=
  //         '<tr><td colspan="12" style="text-align: right; padding-right: 14px; padding-bottom: 0.5rem; font-weight: bold;">Discount: $' +
  //         Number(salesdetails[0]?.Discountentiresale).toFixed(2) +
  //         "</td></tr>";

  //       content +=
  //         '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Total: $' +
  //         Number(salesdetails[0]?.Total).toFixed(2) +
  //         "</td></tr>";
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     // Printing footer-
  //     content += " " + clonedFooter.outerHTML;
  //   }

  //   // Printing page-
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.output("dataurlnewwindow");
  //     },
  //   });
  // };

  const handlePrint = () => {
    window.print(); // Trigger the print dialog
  };

  console.log("saleList 401", saleList);
  console.log("companyDetails 402", companyDetails);
  console.log("customerDetails 403", customerDetails);
  console.log("saleItemList 404", saleItemList);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Sale Receipt</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sales">Sale List</Link>
                </li>
                <li className="breadcrumb-item active">Sale Receipt</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group row">
                <label className="col-form-label col-md-2 form-label">
                  date
                </label>
                <div className="col-lg-10">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={Calendar} alt="img" />
                    </span>
                    <div style={{ width: "100%" }}>
                      <ReactDatetime
                        value={date}
                        onChange={handledate}
                        id="date"
                        name="date"
                        dateFormat="YYYY-MM-DD"
                        timeFormat={false}
                        isValidDate={(currentDate) => {
                          const selectedDate =
                            moment(currentDate).startOf("day");
                          const today = moment().startOf("day");
                          return selectedDate <= today;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Location
                </label>
                <div className="col-md-9">
                  <select
                    className="form-control"
                    name="LocationId"
                    id="LocationId"
                    // value={locationDropdown}
                  >
                    <option value={""}></option>
                    {locationDropdown.map((u, i) => (
                      <option value={u.Id} key={i}>
                        {" "}
                        {u.Name}{" "}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3">Select</label>
                <div className="col-md-9">
                  <select
                    className="form-control"
                    name="Select"
                    id="Select"
                    // value={StateSelected}
                  >
                    <option value="none"> All </option>
                    <option value="Sale"> Sale </option>
                    <option value="Return">Return </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <p className="btn btn-primary me-1" onClick={() => window.print()}>
            Print
          </p>

          {/* Receipt */}
          {saleList?.map((option, index) => {
            return (
              <div
                className="card mt-5 print-page"
                id="print-section"
                key={index}
              >
                <div className="card-body">
                  {/* Header */}
                  <div id="header">
                    {/* Details */}
                    <div className="row">
                      <div className="col-md-4">
                        {/* Company Details */}
                        {companyDetails?.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <div key={index}>
                                <p className="fw-bold">Receiving</p>
                                <span className="fw-bold">
                                  {item.CompanyName}
                                </span>
                                <br />
                                <span>{item.CompanyAddress}</span>
                                <br />
                                <span>{item.Website}</span>
                                <br />
                              </div>
                            </div>
                          );
                        })}

                        {/* Customer Details */}
                        <div className="row mt-3">
                          <div className="col-md-12">
                            {customerDetails
                              ?.filter((x) => x.Id == option.Customerid)
                              ?.map((item, index) => {
                                return (
                                  <div key={index}>
                                    <span className="fw-bold">{item.Name}</span>
                                    <br />
                                    <span>{item.Companyname}</span>
                                    <br />
                                    <span>{item.Address}</span>
                                    <br />
                                    <span>{item.PhoneNumber}</span>
                                    <br />
                                    <span>{item.Country}</span>
                                    <br />
                                    <span>{item.Zip}</span>
                                    <br />
                                    <br />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 ">
                        {companyDetails?.map((item, index) => {
                          return (
                            <img
                              src={item.CompanyLogo}
                              alt={item.CompanyLogo}
                              key={index}
                            />
                          );
                        })}
                        {companyDetails?.CompanyLogo && <h2>Sonar POS</h2>}
                        <div className="row">
                          <div className="col-md-12">
                            <p style={{ marginBottom: "5px" }}>
                              <strong>Shipping Address</strong>
                            </p>
                            {deliveryDetail
                              ?.filter((x) => x.Saleid == option.ID)
                              ?.map((item, index) => {
                                return (
                                  <div key={index}>
                                    <span className="fw-bold">
                                      {item.FirstName}
                                    </span>
                                    <br />
                                    <span>{item.Address1}</span>
                                    <br />
                                    <span>{item.Address2}</span>
                                    <br />
                                    <span>{item.City}</span>
                                    <br />
                                    <span>{item.Country}</span>
                                    <br />
                                    <span>{item.Zip}</span>
                                    <br />
                                    <br />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 ">
                        <div className="row">
                          <div className="col-md-4">
                            <p className="fw-bold" style={{ margin: 0 }}>
                              Original
                            </p>
                          </div>
                          <div className="col-md-8">
                            <p className="fw-bold" style={{ margin: 0 }}>
                              Order Confirmation
                            </p>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row mt-2">
                                <>
                                  <div className="col-md-4">
                                    <p>Invoice No:</p>
                                    {option.InvoiceNo} - Sale
                                  </div>
                                  <div className="col-md-4">
                                    <p>Invoice Date:</p>
                                    <p>{formatDate(option.Saletime)}</p>
                                  </div>
                                  <div className="col-md-4">
                                    <p>Page No:</p>
                                    {currentPage}/
                                    {totalPages === true ? totalPages : 1}
                                  </div>
                                </>
                              </div>

                              <hr />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <p>Customer No:</p>
                                  {option.Customerid}
                                </div>
                                <div className="col-md-8">
                                  Federal Tax ID - Business Partner
                                </div>
                              </div>
                              <hr />
                              <div className="row">
                                <div className="col-md-12">
                                  <p>Your Reference</p>
                                  {customerDetails
                                    ?.filter((x) => x.Id == option.Customerid)
                                    ?.map((item, index) => {
                                      return (
                                        <div key={index}>
                                          {item.InternalNotes}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                              {/* <hr />
                              <div className="row">
                                <div className="col-md-12">
                                  <p>Your Contact</p>
                                  {customerDetails
                                    ?.filter((x) => x.Id == option.Customerid)
                                    ?.map((item, index) => {
                                      return (
                                        <div key={index}>
                                          {item.PhoneNumber}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div> */}
                              <hr />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Currency */}
                    <hr />
                    <div className="d-flex justify-content-between">
                      <p style={{ fontWeight: "bold" }}></p>
                      <p style={{ fontWeight: "bold" }}>Currency : $</p>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="table-responsive" id="body">
                    <table className="table mt-1">
                      <thead>
                        <tr>
                          <th className="col-md">S.No</th>
                          <th className="col-md-3">Description</th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "center" }}
                          >
                            Barcode
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Price
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Quantity
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Discount %
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Tax %
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {saleItemList
                          ?.filter((x) => x.SaleId == option.ID)
                          ?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="col-md">{++index}</td>

                                <td
                                  style={{ textAlign: "left" }}
                                  className="col-md-2"
                                >
                                  <small className="col-md-2">
                                    <strong>{item?.Items}:</strong>
                                    <strong>{item?.ItemVariationName}</strong>
                                  </small>
                                  <p>
                                    Item Number:
                                    {item.Itemnumber}
                                  </p>
                                </td>

                                <td></td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  ${Number(item.Itemunitprice).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Quantitypurchased).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Discountpercent).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Tax).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Total).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>

                    <div className="mt-2 w-100" style={{ textAlign: "right" }}>
                      <p className="fw-bold">
                        Total Amount: ${Number(option.Total).toFixed(2)}
                      </p>
                    </div>
                    <hr />
                  </div>

                  {/* Footer */}
                  <div className="row" id="footer">
                    <div className="col-md-4">
                      <span>CEO:</span>
                      <br />
                      <span>Shareholder:</span>
                      <br />
                      <span>Tax Official</span>
                      <br />
                      <span>Headquarters:</span>
                      <br />
                      <span>Website:</span>
                      <br />
                    </div>
                    <div className="col-md-4">
                      <span>Phone:</span>
                      <br />
                      <span>Fax:</span>
                      <br />
                      <span>E-Mail:</span>
                      <br />
                      <span>Tax No.:</span>
                      <br />
                      <span>Tax ID No.:</span>
                      <br />
                    </div>
                    <div className="col-md-4">
                      <span>Bank Name:</span>
                      <br />
                      <span>Bank Account:</span>
                      <br />
                      <span>Routing Code:</span>
                      <br />
                      <span>Swift/BIC Code:</span>
                      <br />
                      <span>IBAN:</span>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ShowAllReceiptToday;
